<template>
  <div class="HomePage">
    <!-- <div id="app">
            <h1>{{ $t("message.hello") }}</h1>
            <button @click="changeLanguage('zh')">中文</button>
            <button @click="changeLanguage('ja')">日本語</button>
          </div> -->
    <div class="con_box">
      <div class="top_box">
        <div class="top_img" @click="toHome">
          <img src="../assets/logo.jpg" alt="" @click="toHome" />
        </div>
        <div class="top_rig">
          <div @click="toGaiyao" class="tab">{{ $t("home.h2") }}</div>
          <div @click="tojieshao" class="tab">{{ $t("home.h3") }}</div>
          <div class="tab tab1">{{ $t("home.h4") }}</div>
          <div @click="towenxun" class="tab">{{ $t("home.h5") }}</div>
          <!-- <select v-model="selectedOption" @change="handleChange">
            <option disabled value="">请选择</option>
            <option>中文</option>
            <option>日本語</option>
          </select> -->
        </div>
      </div>
      <div class="bg_img">
        <img src="../assets/bg.png" alt="" />
      </div>
      <div class="bg_img">
        <img src="../assets/q1.png" alt="" />
      </div>
      <div class="hudong_title">受け入れ事業実績</div>
      <div class="nei_box">
        <div class="n1_re">
          <div></div>
          <div class="n1_nei">
            現在、当協会は幅広い業界の企業と緊密に連携しております。インターン先は電力会社、お土産屋、ゴルフ場、市役所、不動産事務所、温泉ホテル、スキー場、免税店など、日本語専攻の学生のスキル向上と実務経験の積み重ねに適切な環境を提供しております。
          </div>
        </div>
        <div class="n1_le">
          <img src="../assets/q2.png" alt="" />
        </div>
      </div>
      <div class="title2">参加者からのコメント</div>
      <div class="img_b">
        <img src="../assets/g1.png" alt="" />
        <img src="../assets/g2.png" alt="" />
        <img src="../assets/g3.png" alt="" />
        <img src="../assets/g4.png" alt="" />
      </div>

      <div class="img_o">
        <img src="../assets/g1.png" alt="" />
        <img src="../assets/g2.png" alt="" />
        <img src="../assets/g4.png" alt="" />
        <img src="../assets/g3.png" alt="" />
      </div>
      <!-- <div class="nei_box" style="margin-top: 70px">
        <div class="n1_le">
          <img src="../assets/04.png" alt="" />
        </div>
        <div class="n1_re">
          <div class="n1_re_1">
            私にとって、日本でのインターンシップは「最高の挑戦」でした。<br />
            赤門教育との出会い、熱心で優しい外国の仲間たちとの交流——全てがこの冒険を鮮やかに彩ってくれたのです。<br />
            日本での生活は、充実していて、安心できるものでした。何より「文法が完璧じゃなくてもいい」と開き直り、積極的に話しかけ、スノーボードで山頂に立って仲間と遠くの山並みを眺めた瞬間、「私ってまだこんなに若くて、世界には触れられていない景色や面白い人がこんなにいるんだ」と、胸が熱くなるのを感じました。
          </div>
        </div>
      </div> -->
      <div class="footer">
        <div class="foo_con">
          <div class="fo_le">
            <img src="../assets/logo2.png" alt="" />
            <div class="fo_le_re">
              <div class="fo_top">{{ $t("home.h23") }}</div>
              <div class="fo_le_re_bo">
                <div @click="goToTop">{{ $t("home.h24") }}</div>
                <div @click="toGaiyao">{{ $t("home.h25") }}</div>
                <div @click="tojieshao">{{ $t("home.h26") }}</div>
                <div>{{ $t("home.h27") }}</div>
              </div>
            </div>
          </div>
          <div class="fo_re" @click="towenxun">{{ $t("home.h28") }}</div>
        </div>
        <div class="beian">{{ $t("home.h29") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  props: {
    msg: String,
  },
  data() {
    return {
      value1: 0,
      option1: [
        { text: "中文", value: 0 },
        { text: "日本語", value: 1 },
      ],
      selectedOption: "日本語",
    };
  },
  methods: {
    goToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
    handleChange(event) {
      if (event.target.value == "日本語") {
        this.$i18n.locale = "ja";
      } else if (event.target.value == "中文") {
        this.$i18n.locale = "zh";
      }
    },
    toHome() {
      this.$router.push({ name: "HomePage" });
    },
    toGaiyao() {
      this.$router.push({ name: "GaiYao" });
    },
    tojieshao() {
      this.$router.push({ name: "JieShao" });
    },
    toshiji() {
      this.$router.push({ name: "ShiJi" });
    },
    towenxun() {
      this.$router.push({ name: "WenXun" });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 700px) {
  .con_box,
  .top_box,
  .im_list,
  .foo_con,
  .nei_box,
  .top_img {
    width: 100% !important;
  }
  .top_img img {
    width: 100% !important;
  }
  .top_box,
  .img_box,
  .fo_le,
  .foo_con {
    flex-wrap: wrap;
    margin-bottom: 20px !important;
  }
  .HomePage {
    padding: 0 !important;
  }
  .top_rig {
    gap: 10px !important;
    margin-top: 15px !important;
  }
  .fo_le {
    justify-content: center;
  }
  .fo_le_re {
    align-items: center !important;
  }
  .im_list {
    margin-bottom: 20px !important;
  }
  .hudong_title {
    width: 40% !important;
    font-size: 16px !important;
    height: 40px !important;
  }
  .nei_box {
    flex-direction: column !important;
  }
  .n1_le {
    width: 80% !important;
    margin: 10px auto !important;
  }
  .n1_re {
    width: 100% !important;
    align-items: center !important;
    gap: 20px !important;
  }
  .top_rig {
    gap: 10px !important;
    margin-top: 15px !important;
    font-size: 14px;
    margin: 0 auto;
  }
  .fo_le {
    justify-content: center;
  }
  .fo_le_re {
    align-items: center !important;
  }
  .im_list {
    margin-bottom: 20px !important;
  }
  .footer {
    padding-top: 0 !important;
  }
  .fo_le img {
    width: 100px !important;
    height: 100px !important;
  }
  .foo_con {
    flex-direction: column !important;
  }
  .fo_le {
    flex-direction: column !important;
    align-items: center !important;
    gap: 0 !important;
  }
  .fo_le_re_bo {
    margin-top: 20px !important;
  }
  .beian {
    margin-top: 0 !important;
  }
  .tab1 {
    font-size: 18px !important;
  }
  .n1_re :nth-child(2),
  .n1_re_1 {
    line-height: 30px !important;
  }
  .n1_re {
    width: 90% !important;
    margin: 0 auto !important;
  }
  .hudong_title {
    margin-top: -125px !important;
    margin-bottom: 10px !important;
  }
  .n1_nei {
    font-size: 16px !important;
    line-height: 40px !important;
  }
  .img_b {
    flex-direction: column !important;
  }
  .img_b img {
    width: 100% !important;
  }
  .title2 {
    font-size: 19px !important;
  }
  .img_o {
    display: block !important;
    margin-bottom: 20px !important;
  }
  .img_o img {
    display: block !important;
  }
  .img_b {
    display: none !important;
  }
}
.img_o {
  display: none;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 31px;
}
.img_o img {
  width: 100%;
  display: none;
}
.img_b {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 31px;
}
.img_b img {
  width: 50%;
}
.title2 {
  width: 100%;
  margin: 30px auto;
  font-size: 30px;
  font-weight: 600;
  margin-top: 60px;
}
.img_q3 {
  width: 100%;
}
.img_q3 img {
  width: 100%;
}
.nei_box {
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: 0 auto;
  /* align-items: center; */
  margin-bottom: 30px;
}
.n1_le {
  width: 50%;
}
.n1_le img {
  width: 100%;
}
.n1_re {
  width: 40%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: baseline;
}
.n1_re :nth-child(1) {
  font-size: 20px;
  font-weight: 600;
}
.n1_nei {
  line-height: 60px;
  text-align: left;
  font-size: 25px;
}
.n1_re_1 {
  line-height: 45px;
  text-align: left !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  margin-top: -10px;
}
.hudong_title {
  width: 25%;
  height: 60px;
  font-size: 27px;
  border-radius: 30px;
  background-color: #1e386b;
  margin: 30px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  position: relative;
  z-index: 99;
  margin-top: -470px;
}
/* css */
.HomePage {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}
.con_box {
  width: 90%;
  margin: 0 auto;
}
.fo_le_re_bo div {
  cursor: pointer;
}
.top_box {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top_img {
  display: flex;
  gap: 0px;
  align-items: center;
}

.name_box {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: baseline;
}
.name_box :nth-child(1) {
  font-size: 22px;
  font-weight: 600;
}
.top_rig {
  display: flex;
  gap: 20px;
  align-items: center;
}
.tab1 {
  color: #1e386b;
  font-size: 20px;
  font-weight: 600;
}
.HomePage >>> .van-dropdown-menu__bar {
  width: 115px;
  height: 40px;
  /* box-shadow: none; */
}
.HomePage >>> .van-dropdown-item__content {
  /* right: 222px !important; */
  width: 116px;
}
.HomePage >>> .van-popup--top {
  right: 222px !important;
  left: auto;
}
.van-popup--top {
  right: 222px;
  left: auto;
}
.tab {
  cursor: pointer;
}
.footer {
  background-color: #153266;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 40px;
  box-sizing: border-box;
}
.foo_con {
  width: 80%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 auto;
}
.fo_le {
  display: flex;
  gap: 40px;
}
.fo_le img {
  width: 200px;
  height: 200px;
}
.fo_le_re {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: baseline;
}
.fo_top {
  font-size: 22px;
  font-weight: 600;
  color: #fff;
}
.fo_le_re_bo {
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #fff;
}
.fo_re {
  color: #fff;
  cursor: pointer;
}
.beian {
  text-align: center;
  margin-top: 70px;
  /* margin-bottom: 10px; */
  color: #fff;
}
select {
  width: 100px;
  height: 40px;
  box-shadow: 1px 2px 3px #999;
  border: none;
  text-align: center;
  outline: none;
}
.bg_img {
  width: 100%;
  margin-top: -4px;
}
.bg_img img {
  width: 100%;
}
</style>
